module.exports = __webpack_public_path__ + "static/media/plus-circle.2b2138f3.svg";